export const stages = [
    {   
        title: "Stage 1. Q3 2022",
        subtitle: "MVP game application",
        list: ["Playable version","Basic PVP","Launch of gaming NFT marketplace","Overall rating of the players", "Pilots logic"],
        id: 1

    },
    {   
        title: "Stage 2. Q4 2022",
        subtitle: "Alpha version",
        list: ["50% of release content","Non linear global quests and events","Active SMM and NFT sale"],
        id: 2

    },
    {   
        title: "Stage 3. Q1 2023",
        subtitle: "Beta version",
        list: ["Lands ownership logic", "Vassal system", "Cinematic video reports"],
        id: 3

    },
    {   
        title: "Stage 4. Q2 2023",
        subtitle: "Beta version",
        list: ["Season 1 global plot with 7 campains","Vassal system","Cinematic video reports"],
        id: 4

    },
    {   
        title: "Stage 5. Q3 2023",
        subtitle: "Release version",
        list: ["PVE monsters","First season global plot","Animated CG for global plot","Dynamic building of global plot for season 2"],
        id: 5

    }

]